import { render, staticRenderFns } from "./4mVendorList.vue?vue&type=template&id=250f7f20"
import script from "./4mVendorList.vue?vue&type=script&lang=js"
export * from "./4mVendorList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('250f7f20')) {
      api.createRecord('250f7f20', component.options)
    } else {
      api.reload('250f7f20', component.options)
    }
    module.hot.accept("./4mVendorList.vue?vue&type=template&id=250f7f20", function () {
      api.rerender('250f7f20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/4m/4mVendorList.vue"
export default component.exports